<template>
  <app-base-main style="height: 100%; box-sizing: border-box;" :no-padding="!padding"
                 :table-shadow="tableShow"
  >
    <template #filter-group>
      <WG-filter
          :asinType="asinType"
          ref="listingFilter"
          :query-loading="queryBtnLoading"
          :init-date="initDate"
          :filter="params"
          @finish="finish"
          @reset="reset"
          :show-currency="statisticsField === 'orderProductSales'"
          @set-pagination="setPagination"
          @search="search">
        <template #default>
          <gj-radio-group v-if="clientWidth > 1366"
                          v-model="dateQueryType"
                          :options="option.rangeRadio">
          </gj-radio-group>
          <gj-select v-if="clientWidth <= 1366"
                     v-model="dateQueryType"
                     :options="option.rangeRadio"
                     width="60px"
                     :clearable="false">
          </gj-select>
        </template>
      </WG-filter>
    </template>
    <template #operate-group>
      <gj-radio-group
          class="strColor"
          v-model="statisticsField"
          :options="option.analysisRadio"
          @input="$gjNoticeQuery">
      </gj-radio-group>
    </template>
    <template #tool-group>
      <gj-tool-group
        setting
        table-type="vxe-virtual-tree"
        :table-name="tableName"
        :table-columns="columns"
        :sort-gjtable="$refs.gjTable"
        :download="$permission('listingStatistics:export')"
        download-url="/operation/listingAnalyze/statistics/export"
        :download-params="globalParams"
        help>
        <template #before>
          <gj-checkbox v-model="showTestOrder">
            <span style="color: #666">推广订单</span>
          </gj-checkbox>
        </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-tree-table :list="tableData"
                     ref="gjTable"
                     :loading="loading"
                     :columns="columns"
                     :params="params"
                     class="listing-statistics-copy-table"
                     :pagerConfig="pagination"
                     :show-summary="isMeaningful(summaryObject)"
                     :summary-object="summaryObject"
                     @sort-change="$gjSortChange"
                     @page-change="$gjNoticeQuery">
<!--        :default-sort="sort"-->
        <template v-slot:image="{row}">
          <gj-image :src="row.imageUrl"></gj-image>
        </template>
        <!-- <template v-slot:listingInfo-header>
          <span v-if="params.groupType === 'asin'">ASIN/售价</span>
          <span v-else-if="params.groupType === 'variationAsin'">父ASIN/售价</span>
          <span v-else-if="params.groupType === 'msku'">MSKU/ASIN</span>
        </template> -->
        <template v-slot:listingInfo="{row}">
          <template v-if="params.groupType === 'asin'">
            <div>
              <gj-text>
                <gj-link :href="row.asinUrl"
                         target="_blank">{{ row.asin | defaultShow }}
                </gj-link>
              </gj-text>
              <!-- 复制指令 -->
              <gj-icon v-if="row.asin"
                       v-copy="defaultShow(row.asin)"
                       class="el-icon-copy-document table-tree-icon"></gj-icon>
            </div>
            <div>{{ row.salePrice | defaultShow(row.currencySymbol) }}</div>
          </template>
          <template v-else-if="params.groupType === 'variationAsin'">
            <div>
              <gj-text>
                <template v-if="row.parent">
                  <gj-link :href="row.variationAsinUrl"
                           target="_blank">{{ row.variationAsin | defaultShow }}
                  </gj-link>
                  <gj-icon v-copy="defaultShow(row.variationAsin)"
                           class="el-icon-copy-document table-tree-icon"></gj-icon>
                </template>
                <template v-else>
                  <gj-link :href="row.asinUrl"
                           target="_blank">{{ row.asin | defaultShow }}
                  </gj-link>
                  <gj-icon v-copy="defaultShow(row.asin)"
                           class="el-icon-copy-document table-tree-icon"></gj-icon>
                </template>
              </gj-text>
            </div>
            <div>{{ row.salePrice | defaultShow(row.currencySymbol) }}</div>
          </template>
          <template v-else-if="params.groupType === 'msku'">
            <el-row type="flex">
              <gj-text max-width="90%">{{ row.msku | defaultShow }}</gj-text>
              <gj-icon v-copy="defaultShow(row.msku)"
                       class="el-icon-copy-document table-tree-icon"></gj-icon>
            </el-row>
            <!--            <el-row type="flex">-->
            <!--              <gj-text max-width="90%">-->
            <!--                <gj-link :href="row.asinUrl"-->
            <!--                  target="_blank">{{row.asin | defaultShow}}</gj-link>-->
            <!--              </gj-text>-->
            <!--              <gj-icon v-copy="row.asin"-->
            <!--                class="el-icon-copy-document table-tree-icon"></gj-icon>-->
            <!--            </el-row>-->
          </template>
        </template>
        <template v-slot:asins="{row}">
          <gj-icon iconfont="iconshuju1"
                   class="analysis-icon"
                   @click.native="handleNavigateAsin(row)"></gj-icon>
        </template>
        <template v-slot:listingMarketName="{row}">
          <template v-if="params.groupType === 'asin' || params.groupType === 'variationAsin'">
            <template v-if="row.parent && row.items && row.items.length > 1">{{ row.country | defaultShow }}</template>
            <template v-else>{{ row.marketName | defaultShow }}</template>
          </template>
          <template v-else>
            {{ row.marketName | defaultShow }}
          </template>
        </template>
        <template v-slot:product="{row}">
          <gj-text width="100%">{{ row.skuName | defaultShow }}</gj-text>
          <el-row type="flex">
            <template v-if="row.sku">
              <gj-popover-panel v-if="row.marketSkuList && row.marketSkuList.length > 1"
                                placement="right"
                                :width="'250px'"
                                :data="row.marketSkuList">
                <gj-text max-width="90%">{{ row.sku | defaultShow }}</gj-text>
              </gj-popover-panel>
              <template v-else>{{ row.sku | defaultShow }}</template>
            </template>
            <template v-else>-</template>
          </el-row>
        </template>
        <template v-slot:variationAsin="{row}">
          <template v-if="row.variationAsin">
            <gj-link :href="row.variationAsinUrl"
                     target="_blank">{{ row.variationAsin | defaultShow }}
            </gj-link>
            <gj-icon v-copy="row.variationAsin"
                     class="el-icon-copy-document table-tree-icon"></gj-icon>
          </template>
          <template v-else>-</template>
        </template>
        <template v-slot:fulfillableQuantity="{ row }">
          <gj-popover-panel title="FBA可售"
                            :width="'180px'"
                            :data="buildFBA(row)">
            {{ row.fulfillableQuantity | defaultShow }}
          </gj-popover-panel>
        </template>
        <template v-slot:saleableTurnover="{ row }">
          {{ row.saleableTurnover | defaultShow }}
        </template>
        <template v-slot:fulfillableQuantityFBM="{ row }">
          <gj-popover-panel title="FBM可售"
                            :width="'180px'"
                            :data="buildFBM(row)">
            {{ row.fulfillableQuantityFBM | defaultShow }}
          </gj-popover-panel>
        </template>
        <template v-slot:saleableTurnoverFBM="{ row }">
          {{ row.saleableTurnoverFBM | defaultShow }}
        </template>
        <template v-for="(slotName, index) in dynamicSlots" v-slot:[slotName]="{row}">
          <div :key="index">
            <template v-if="statisticsField === 'orderProductSales'">
              <div>{{ row[slotName] | defaultShow(row.currencySymbol) }}</div>
              <div v-if="showTestOrder">{{ row[`${slotName}-bogus`] | defaultShow(row.currencySymbol) }}</div>
            </template>
            <template v-else>
              <div>{{ row[slotName] | defaultShow }}</div>
              <div v-if="showTestOrder">{{ row[`${slotName}-bogus`] | defaultShow }}</div>
            </template>
          </div>
        </template>

        <template v-slot:crawlTitle="{row}">
          <gj-tooltip :content="row.crawlTitle" :textLine="2">{{row.crawlTitle | defaultShow}}</gj-tooltip>
        </template>
        <template v-slot:categoryName="{ row }">
          <gj-tooltip :content="row.categoryName" :textLine="2">{{row.categoryName | defaultShow}}</gj-tooltip>
        </template>
        <template v-slot:brandName="{ row }">
          <gj-tooltip :content="row.brandName" :textLine="2">{{row.brandName | defaultShow}}</gj-tooltip>
        </template>
        <template v-slot:sellingManagerNames="{ row }">
          <gj-tooltip :content="row.sellingManagerNames" :textLine="2">{{row.sellingManagerNames | defaultShow}}</gj-tooltip>
        </template>
      </gj-tree-table>
    </template>
  </app-base-main>
</template>

<script>
import _ from 'lodash'
import WGFilter from '@/views/modules/statistics/common/analysis/goods-analysis/widget/filter';
import {DATE_SHORTCUTS} from "@/utils/const";
// panding和shadow样式的处理
import {analysisMixin} from "@/views/modules/statistics/common/analysis/mixins";
// 对筛选区域的  参数的处理
import {queryMixin, noRepeatQueryMixin, dashboardMixin} from "@/minxins";
import {getListingStatisticsAnalysis} from "@/api/statistics";
import {isMeaningful} from "@/utils/common";
import {convertToFullDate} from "@/utils/date.util";
import {columns1} from './data.js'
import {defaultShow} from '@/filters'

export default {
  components: {WGFilter},
  name: 'app-listing-statistics-new',
  mixins: [analysisMixin, queryMixin, noRepeatQueryMixin, dashboardMixin],
  // 通过路由里面的props 传递的参数
  props: ['startDate', 'endDate', 'asinType'],
  
  data() {
    return {
      isMeaningful,
      tableData: [],
      columns: [],
      statisticsField: 'unitsOrdered',
      dateQueryType: 'day',
      params: {
        groupType: 'asin',
        currency: '',
        categoryIds: null,
        brandId: null,
        countryAndMarket: null,
        keyword: {
          key: 'asin',
          value: null,
        },
        date: null,
        userPermission: null,
        chargeIdList: null,
      },
      option: {
        analysisRadio: [
          {id: 'unitsOrdered', text: '销量'},
          {id: 'orders', text: '订单量'},
          {id: 'orderProductSales', text: '销售额'},
          {id: 'returns', text: '退货量'},
          {id: 'refunds', text: '退款量'},
        ],
        rangeRadio: [
          {id: 'day', text: '天'},
          {id: 'week', text: '周'},
          {id: 'month', text: '月'},
        ],
      },
      showTestOrder: false,
      summaryObject: null,
      isDisableInitHttp: true,
      cacheOptions: {
        filterKey: 'params'
      },
      dynamicSlots: []
    }
  },
  watch:{
    asinType(){
      if (this.asinType!== 'shop') {
        this.params.groupType = this.asinType;
        // this.handleColumn(this.asinType)
      }
    }
  },
  created() {
    this.params.groupType = this.asinType;
    this.cacheOptions.filterKey = this.asinType;
    this.filterKey =  this.asinType;
    this.sort.prop = 'subtotal';
    this.handleColumn(this.params.groupType)
    const tabs = this.$cacheTab.getCache()
    if (tabs.val) {
      this.statisticsField = tabs.val
    }
    let cacheData = this.getCacheData()
    if (cacheData && cacheData.pagination) {
      this.pagination.pageSize = cacheData.pagination.pageSize
    }
    this.params.countryAndMarket = this.startDate ? this.countryMarket : null
  },
  activated() {
    // 每次进入组件判断是否为dashboard跳转过来的, 是站点店铺数据源去dashboard选中数据
    this.params.countryAndMarket = this.startDate ? this.countryMarket : null
  },
  computed: {
    tableName() {
      return `'listingAnalysisStatistics'${this.params.groupType}`
    },
    initDate() {
      return this.startDate ? [this.startDate, this.endDate] : DATE_SHORTCUTS.last14Day.date;
    }
  },
  methods: {
    customCacheCallback() {
      this.setCacheData()
      this.$cacheTab.setCache({params: {val: this.statisticsField}})
    },
    $gjCacheCallback(params) {
      return {
        groupType: params.groupType,
        countryAndMarket: params.countryAndMarket
      };
    },
    search(params) {
      //切换tab时，清空已保存的排序选项、初始化排序
      this.$refs.gjTable.sortOption = null;
      this.sort.prop = 'subtotal';

      this.params = params;
      this.pagination.currentPage = 1;
      this.$gjNoticeQuery();
    },
    reset(params) {
      this.params = params;
      this.pagination.currentPage = 1;
      this.$cacheTab.removeCache()
      this.statisticsField = 'unitsOrdered'
      this.pagination.pageSize = 20
      this.$gjReset()
    },
    setPagination(pages) {
      this.pagination.pageSize = pages.pageSize || 20
    },
    finish(params) {
      this.params = params;
      this.$gjQuery()
    },
    // 切换tab columns数据变化
    handleColumn(val) {
      columns1.map(v => {
        v.checked = true
        return v
      })
      const index = columns1.findIndex(v => v.field === 'listingInfo')
      if (val === 'variationAsin') {
        columns1[index].title = '父ASIN/售价'
        columns1[index].sortBy = 'variationAsin';
      } else if (val === 'asin') {
        columns1[index].title = 'ASIN/售价';
        columns1[index].sortBy = 'asin';
      } else {
        columns1[index].title = 'MSKU'
        columns1[index].sortBy = 'msku';
      }
      // //  产品/sku
      // let index1 =  columns1.findIndex(m=>m.field==='product');
      // columns1[index1].sortable = val === 'asin' || val === 'variationAsin';

      let columns = _.cloneDeep(columns1)
      if (val === 'asin') {
        const arr = ['crawlTitle','asin']
        for (let i in arr) {
          columns.splice(columns.findIndex(v => v.id === arr[i]), 1)
        }
      } else if (val === 'variationAsin') {
        const arr = ['crawlTitle','parentAsin', 'asin']
        for (let i in arr) {
          columns.splice(columns.findIndex(v => v.id === arr[i]), 1)
        }
      } else if (val === 'msku') {
        const arr = ['asins']
        for (let i in arr) {
          columns.splice(columns.findIndex(v => v.id === arr[i]), 1)
        }
      }
      this.columns = columns
    },
    $gjQuery() {
      this.resetSort();
      // 切换类型时，若前者正在使用的排序字段未在后者能排序的列中，则回到默认排序的地方
      const sortData={
        // variationAsin: ['asin', 'sku', 'msku'],
        // asin: ['msku'],
        // msku: ['variationAsin', 'sku']
        variationAsin: ['asin', 'sku', 'msku'],
        asin: ['msku'],
        msku: ['variationAsin', 'sku']
      }
      if(sortData[this.params.groupType].includes(this.sort.prop)){
        this.sort.prop = 'subtotal';
      }

      this.loading = true;
      this.queryBtnLoading = true;
      let params = {
        model: {
          ...this.params,
          dateQueryType: this.dateQueryType,
          statisticsField: this.statisticsField
        },
        ...this.queryPagination,
        ...this.querySort
      }
      this.globalParams = params
      getListingStatisticsAnalysis(params).then(res => {
        const {data} = res
        this.handleColumn(this.params.groupType);
        this.dynamicSlots = data.other
        // 添加动态列
        this.buildCol(data.other);
        this.tableData = data.records.map((item, index) => {
          if (item.expandItems && item.expandItems.length > 1) {
            item.parent = true;
            item.marketSkuList = [{label: '产品名称', value: 'SKU', bold: true}, ...(item.expandItems || []).map(v => ({
              label: v.col1,
              value: v.col2
            }))]
          }
          if (item.items && item.items.length > 0) {
            item.parent = true;
            item.items.map(childItem => {
              childItem.marketSkuList = [{
                label: '产品名称',
                value: 'SKU',
                bold: true
              }, ...(childItem.expandItems || []).map(v => ({
                label: v.col1,
                value: v.col2
              }))]
            })
          }
          item.index = index + 1
          return item
        })
        this.summaryObject = data.statisticRecord;
        this.pagination = this.getPagination(data);
      })
          .complete(() => {
            this.loading = false;
            this.queryBtnLoading = false;
          });
    },

    /**
     * popover详情
     * @param row
     */
    buildFBA(row) {
      return [
        [
          {label: 'FBA可售', value: row.fulfillableQuantity}
        ],
        [
          {label: '转运中', value: row.reservedTransfers},
          {label: '处理中', value: row.reservedProcessing},
          {label: '小计', value: row.reservedSum, bold: true},
        ],
        [
          {label: '计划入库', value: row.planInboundQuantityFBA},
          {label: '已发货', value: row.alreadyShipQuantity},
          {label: '入库中', value: row.inboundingQuantity},
          {label: '小计', value: row.quantityFBA, bold: true}
        ]
      ]
    },
    /**
     * popover详情
     */
    buildFBM(row) {
      return [
        [
          {label: 'FBM可售', value: row.fulfillableQuantityFBM}
        ],
        [
          {label: '采购量', value: row.purchaseQuantity},
          {label: '已下单', value: row.alreadyOrderQuantity},
          {label: '交货量', value: row.deliveryQuantity},
          {label: '计划入库', value: row.planInboundQuantityFBM},
          {label: '小计', value: row.quantityFBM, bold: true}
        ]
      ]
    },
    /**
     * 跳转asin看板
     * @param row
     */
    handleNavigateAsin(row) {
      const queryParams = {
        asinType: this.params.groupType === 'variationAsin' ? 'parent' : 'child',
        asinCode: this.params.groupType === 'variationAsin' ? row.variationAsin : row.asin,
        countryData: {
          countryIds: [row.country], // 国家
          marketIds: [row.marketId], // 店铺
        },
        date: {
          type: 'DAY',
          value: [
            convertToFullDate(this.params.date[0], 'yyyy-MM-dd'),
            convertToFullDate(this.params.date[1], 'yyyy-MM-dd'),
          ]
        }
      };
      if (this.params.groupType === 'variationAsin') {
        // params.asinType = row.parent ? 'parent' : 'child'
        // params.asinCode = row.parent ? row.variationAsin : row.asin
        if (row.parent && row.variationAsin) {
          queryParams.asinType = 'parent'
          queryParams.asinCode = row.variationAsin
        } else {
          queryParams.asinType = 'child'
          queryParams.asinCode = row.asin
        }
      }
      this.$router.push({path: '/statistics/asin-361-analysis', query: {params: JSON.stringify(queryParams)}})
    },
    // 添加动态列
    buildCol(other) {
      const arr = other.map(v => {
        const item = {
          id: v,
          title: v.includes('~') ? v.split('~').join('\n') : format(v),
          field: v,
          minWidth: '120px',
          align: 'right',
          summary: true,
          sortable: true,
          fasten: true,
          checked: true,
          slots: {
            default: v
          }
        }
        if (this.statisticsField === 'orderProductSales') {
          item.prefix = 'currencySymbol'
        }
        return item
      })

      function format(v) {
        return v.split('-').splice(1, 2).join('-')
      }

      const subTotal = {
        id: 'subtotal',
        title: '日期汇总',
        field: 'subtotal',
        width: '100px',
        align: 'right',
        summary: true,
        sortable: true,
        fixed: 'right',
        fasten: true,
        checked: true
      }
      if (this.statisticsField === 'orderProductSales') {
        subTotal.prefix = 'currencySymbol'
      }
      this.columns = [...this.columns, ...arr, subTotal]
    },
    defaultShow
  }
}
</script>

<style lang="scss">
.vxe-grid-height {
  height: 100%;

  .table {
    height: calc(100% - 90px);

    .analysis-icon {
      font-size: 21px;
      color: #1F6EEF;
      cursor: pointer;
    }
  }

  .vxe-table--render-default:not(.is--empty).is--footer.is--scroll-x .vxe-table--body-wrapper {
    overflow-x: hidden;
  }
}

// .listing-statistics-copy-table .fixed-left--wrapper.vxe-table--body-wrapper  {
//   overflow-x: hidden !important;
// }
</style>

<style lang="scss" scoped>
.analysis-icon {
  font-size: 21px;
  color: #1F6EEF;
  cursor: pointer;
}

/deep/ .filter-group__advanced {
  // margin-top: 0;
}

/deep/ .table {
  flex: 1;
  overflow: auto;

  .vxe-body--row {
    .vxe-body--column {
      height: 54px !important;
    }
  }
}

.strColor {
  /deep/ .el-radio-button__inner {
    color: #666;
  }
}
</style>
